import Airport from '../airport'
import { SiteCountry } from '../locale'
import { destinationEnum } from './destination'

export type CountryAirports = [SiteCountry, Airport[]]

export function getAirportNames(
  value: CountryAirports[],
  siteCountry: SiteCountry,
) {
  const airports = new Map(value).get(siteCountry)
  if (typeof airports !== 'undefined') {
    return airports.map(e => e.name).join(', ')
  }
  return ''
}

export function getVisibleAirports(
  airports: Airport[],
  destination: destinationEnum,
) {
  const values: Airport[] = []
  airports.forEach(airport => {
    if (
      !(airport.hideOutsideEU && destination === destinationEnum.outsideEurope)
    ) {
      values.push(airport)
    }
  })
  return values
}
